module.exports = __webpack_public_path__ + "static/peng_jk_mau-5f026a1203295f74bbf57f35c615ef16.png";